// extracted by mini-css-extract-plugin
export default {"checkbox":"_0MOif","checkbox-default":"JU0zj","checkboxDefault":"JU0zj","checkbox-error":"a1Reg","checkboxError":"a1Reg"};